const defaultEmojiMap = new Map<string, string>([
  [':)', '😊'],
  [':-)', '😊'],
  ['(:', '😊'],
  ['(-:', '😊'],
  [':-|', '😐'],
  [':|', '😐'],
  [':-(', '☹️'],
  [':(', '☹️'],
  [':-D', '😀'],
  [':D', '😀'],
  [':-p', '😛'],
  [':p', '😛'],
  [':-P', '😛'],
  [':P', '😛'],
  [':-o', '😲'],
  [':o', '😲'],
  [':O', '😲'],
  [':-O', '😲'],
  [':-0', '😲'],
  [':0', '😲'],
  [';-)', '😉'],
  [';)', '😉'],
  ['<3', '❤️'],
  ['</3', '💔'],
  ['<\\3', '💔']
]);

export default defaultEmojiMap;
